import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    turnUP : false,
    rooms : [],
    room : {},
    currentRoomId: '',
    disabledDates: [
      // "2019-08-29",
      // "2019-08-30",
      // "2019-09-15",
      // "2019-09-16",
      // "2019-09-17",
      // "2019-09-26",
      // "2019-09-28"
    ]
  },
  mutations: {
    changeTurnUP(state){
      state.turnUP = !state.turnUP
    },
    setRoomsInfo(state,val){
      state.rooms = val
    },
    setRoomInfo(state,val){
      state.room = val
    },
    disabledDatesInRoom(state,val){
      if(val){
        val.map(x=>{state.disabledDates.push(x.date)})
      }else{
        state.disabledDates = []
      }
    }
  },
  actions: {
    getRoomsInfo( {commit , state} ){
      axios.get('https://challenge.thef2e.com/api/thef2e2019/stage6/rooms',
      {headers:{
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": "Bearer qTrae8muEk30QZHfTNwoaG2ou1fTMMfwvGvcTDxxQ2mJn0muDfqrnDXRmuRW",
        "cache-control": "no-cache"
      }})
      .then(res=>{
        if(res.data.success){
          commit('setRoomsInfo',res.data.items)
        }
      })
    },
    getRoomInfo( {commit , state}, obj ){
      commit('disabledDatesInRoom')
      axios.get('https://challenge.thef2e.com/api/thef2e2019/stage6/room/' + obj.roomId,
      {headers:{
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": "Bearer qTrae8muEk30QZHfTNwoaG2ou1fTMMfwvGvcTDxxQ2mJn0muDfqrnDXRmuRW",
        "cache-control": "no-cache"
      }})
      .then(res=>{
        if(res.data.success){
          commit('setRoomInfo',res.data.room[0]);
          commit('disabledDatesInRoom',res.data.booking)
        }
      })
    },
    bookingRoom( {commit , state},obj){
      console.log(obj)
      axios.request({
        url: `https://challenge.thef2e.com/api/thef2e2019/stage6/room/${obj.info.roomId}`,
        method: 'post',
        headers: {
          'Accept':'application/json',
          "Content-Type": "application/json",
          "Authorization": "Bearer qTrae8muEk30QZHfTNwoaG2ou1fTMMfwvGvcTDxxQ2mJn0muDfqrnDXRmuRW",
          "cache-control": "no-cache"
        }, 
        data: {
          name: obj.info.name,
          tel: obj.info.tel,
          date: obj.info.date
        }
      })
      .then(res => {
        console.log(res);
      }).catch(error => {
        if(error.response){
          alert(error.response.data.message);
        }
      });
    }
  }
})
